import { render, staticRenderFns } from "./groupSMS.vue?vue&type=template&id=32fbb4ca&scoped=true&"
import script from "./groupSMS.vue?vue&type=script&lang=js&"
export * from "./groupSMS.vue?vue&type=script&lang=js&"
import style0 from "./groupSMS.vue?vue&type=style&index=0&id=32fbb4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbb4ca",
  null
  
)

export default component.exports